import React, { Component } from "react";
import Intro from "../Components/Intro";
import ShowWork from "../Components/ShowWork";
import data from "../Data/data";

export default class Content extends Component {
  constructor() {
    super();
    this.state = {
      slideCountForReturn: 0,
      itemDisplayNo: 1
    };
  }
  slide = () => {
    if (this.state.itemDisplayNo === data.length) {
      this.setState({ itemDisplayNo: 1 });
    } else {
      this.setState((prevState) => {
        return{
          ...prevState,
          itemDisplayNo: prevState.itemDisplayNo + 1
        }
      })
      // this.setState({ itemDisplayNo: this.state.itemDisplayNo + 1 });
    }
    const screenWidth = document.querySelector(".main").clientWidth;
    const marginLeft = 16;

    const index = this.state.slideCountForReturn === 2 ? -1 : this.state.slideCountForReturn + 1;
    this.setState({
      slideCountForReturn: index
    });
    const editPixels = document.querySelector(".work_snapshot").firstChild
      .clientWidth;
    const parentWidth = document.querySelector(".show_work").clientWidth;

    const gapLeft = ((parentWidth * marginLeft) / 100).toFixed(2);
    const editGap = (Number(gapLeft) + Number(editPixels)) * (this.state.slideCountForReturn + 1);
    document.querySelector(".show_work").style = `margin-left:-${editGap}px`;
  };
  render() {
    return (
      <main className="main">
        <Intro
          num={this.state.itemDisplayNo}
          runOnEnter={this.props.runOnEnter}
          runOnLeave={this.props.runOnLeave}
        />
        <ShowWork
          runOnEnter={this.props.runOnEnter}
          runOnLeave={this.props.runOnLeave}
        />
        <div className="go-right">
          <button
            onClick={() => {
              this.slide();
            }}
            onMouseEnter={() => this.props.runOnEnter()}
            onMouseLeave={() => {
              this.props.runOnLeave();
            }}
          >
            />
          </button>
        </div>
      </main>
    );
  }
}
